import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_ATTACHMENT,
    GET_GENERAL,
    GET_PROFILE_ATTACHMENT,
    GET_THUMBNAIL_ATTACHMENT,
    GET_VOUCHER_LIST,
    GET_SERVICE_LIST,
} from "./actionTypes.js";

import {
    getGeneralSuccess,
    getGeneralFail,
    getAttachmentSuccess,
    getAttachmentFail,
    getProfileAttachmentSuccess,
    getProfileAttachmentFail,
    getThumbnailAttachmentSuccess,
    getThumbnailAttachmentFail,
    getVoucherListSuccess,
    getVoucherListFail,
    getServiceListSuccess,
    getServiceListFail,
} from "./action.js"

import {
    attachmentApi,
    generalApi,
    voucherListApi,
    serviceListApi
} from "./generalApi.js"

function* fetchGeneral() {
    try {
        const response = yield call(generalApi)
        yield put(getGeneralSuccess(response))
    } catch (error) {
        yield put(getGeneralFail(error))
    }
}

function* fetchVoucherList({ payload }) {
    try {
        const response = yield call(voucherListApi, payload)
        yield put(getVoucherListSuccess(response))
    } catch (error) {
        yield put(getVoucherListFail(error))
    }
}

function* fetchServiceList({ payload }) {
    try {
        const response = yield call(serviceListApi, payload)
        yield put(getServiceListSuccess(response))
    } catch (error) {
        yield put(getServiceListFail(error))
    }
}

function* fetchAttachment({ payload }) {
    try {
        const response = yield call(attachmentApi, payload)
        yield put(getAttachmentSuccess(response))
    } catch (error) {
        yield put(getAttachmentFail(error))
    }
}

function* fetchProfileAttachment({ payload }) {
    try {
        const response = yield call(attachmentApi, payload)
        yield put(getProfileAttachmentSuccess(response))
    } catch (error) {
        yield put(getProfileAttachmentFail(error))
    }
}

function* fetchThumbnailAttachment({ payload }) {
    try {
        const response = yield call(attachmentApi, payload)
        yield put(getThumbnailAttachmentSuccess(response))
    } catch (error) {
        yield put(getThumbnailAttachmentFail(error))
    }
}

function* GeneralSaga() {
    yield takeEvery(GET_GENERAL, fetchGeneral)
    yield takeEvery(GET_VOUCHER_LIST, fetchVoucherList)
    yield takeEvery(GET_SERVICE_LIST, fetchServiceList)
    yield takeEvery(GET_ATTACHMENT, fetchAttachment)
    yield takeEvery(GET_PROFILE_ATTACHMENT, fetchProfileAttachment)
    yield takeEvery(GET_THUMBNAIL_ATTACHMENT, fetchThumbnailAttachment)
}

export default GeneralSaga
